// extracted by mini-css-extract-plugin
export var boldText = "_5o-4";
export var checkboxContainer = "_5o-6";
export var closeIcon = "_5o-i";
export var container = "_5o-0";
export var drawer = "_5o-8";
export var drawerContent = "_5o-9";
export var extraSmallText = "_5o-5";
export var fulfillmentGroupTable = "_5o-e";
export var largeText = "_5o-3";
export var loadingSpinnerContainer = "_5o-j";
export var mediumText = "_5o-2";
export var narrow = "_5o-f";
export var notificationLink = "_5o-l";
export var packageCheckIconContainer = "_5o-7";
export var slideoutHeaderActions = "_5o-g";
export var slideoutHeaderActionsShifted = "_5o-h";
export var slideoutHeaderContainer = "_5o-a";
export var slideoutModal = "_5o-c";
export var stickyHeaderWrapper = "_5o-b";
export var table = "_5o-k";
export var tableContainer = "_5o-d";
export var tertiaryText = "_5o-1";